module.exports = __webpack_public_path__ + "media/images/front/about/e-mediceo/cc_renewal_pc_005-bb27885f4ee1529e61d9140328f48af4.png";